namespace Portico.Models.Enterprise {

    export interface ISurveyQuestion {
		questionId: number | string;
        questionTypeId: number;
        questionText: string;
        audioFileName: string;
        isSurveyEntryPoint: boolean;
        isOptInQuestion: boolean;
        surveyAnswers: SurveyAnswer[];
		questionCategories: any[];

		getSurveyAnswer: (answerId: number) => SurveyAnswer;
	}

    export class SurveyQuestion implements ISurveyQuestion {
		questionId: number | string;
        questionTypeId: number;
        questionText: string;
        audioFileName: string;
        isSurveyEntryPoint: boolean;
        isOptInQuestion: boolean;
        surveyAnswers: SurveyAnswer[];
		questionCategories: any[];

        constructor(obj?: ISurveyQuestion | any) {
            this.questionId = null;
            this.questionTypeId = null;
            this.questionText = null;
            this.audioFileName = null;
            this.isSurveyEntryPoint = null;
            this.isOptInQuestion = null;
			this.surveyAnswers = [];
			this.questionCategories = [];

            if (obj) {
				this.questionId = obj.questionId || null;
                this.questionTypeId = obj.questionTypeId || null;
				this.questionText = obj.questionText || null;
                this.audioFileName = obj.audioFileName || null;
                this.isSurveyEntryPoint = obj.isSurveyEntryPoint || null;
                this.isOptInQuestion = obj.isOptInQuestion || null;

				if (obj.surveyAnswers || obj.answers) {
					for (const surveyAnswer of obj.surveyAnswers || obj.answers) {
						this.surveyAnswers.push(new SurveyAnswer(surveyAnswer));
					}
				}

				//if (obj.questionCategories) {
				//	for (const questionCategory of obj.questionCategories) {
				//		this.questionCategories.push(new QuestionCategory(questionCategory));
				//	}
				//}
            }
        }

		getSurveyAnswer(answerId: number): SurveyAnswer {
			const matches = this.surveyAnswers.filter((surveyAnswer) => {
				return surveyAnswer.answerId === answerId;
			});

			return matches && matches.length > 0 ? matches[0] : null;
		}
    }
}
